// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__2fWtX","main-content":"layout_main-content__FkOxN"};